import dayjs from 'dayjs';
import { useRef } from 'react';
import Flatpickr from 'react-flatpickr';
import { CrossIcon, EditIcon, SaveIcon } from '../../../utils/SVGIcon';
import { useProfileInfo } from '../UserProfileProvider';

function ActionButton({
    isEditMode,
    handelOnChange,
    saveClick,
    handleButtonClick,
    flatpickrRef,
    calenderValue,
    cancelEditClick
}) {
    if (isEditMode) {
        return (
            <div className="flex justify-center items-center gap-1.5">
                <button
                    type="button"
                    onClick={saveClick}
                    className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full"
                >
                    <SaveIcon />
                </button>
                <button
                    type="button"
                    onClick={cancelEditClick}
                    className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 text-[#506B76] rounded-full"
                >
                    <CrossIcon className="w-full h-full" />
                </button>
            </div>
        );
    }
    return (
        <button type="button" onClick={() => handleButtonClick()} className="block relative">
            <span className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full">
                <EditIcon />
            </span>

            <Flatpickr
                name="date"
                ref={flatpickrRef}
                value={calenderValue()}
                onChange={handelOnChange}
                className="absolute top-0 -left-1/2 opacity-0 w-0 h-0"
                options={{ maxDate: dayjs().format('YYYY-MM-DD') }}
            />
        </button>
    );
}

function UserDobInfoCard({ title, name, value, saveClick }) {
    const { handleChange, formData, handleReset, propertyName } = useProfileInfo();

    const flatpickrRef = useRef();

    // --handle input data on change and modify the date format
    const handelOnChange = ([date]) => {
        const ev = {
            target: {
                name,
                value: date ? dayjs(date).format('YYYY-MM-DD') : ''
            }
        };
        handleChange(ev);
    };

    // --handler for open the flatpickr calender
    const handleButtonClick = () => {
        if (flatpickrRef.current) {
            flatpickrRef.current.flatpickr.toggle();
        }
    };

    // default value
    const inputValue = () => {
        if (formData[name] && typeof formData[name] === 'number') {
            return dayjs(formData[name] * 1000)?.format(`DD ${`MMMM`.slice(0, 3)} YYYY`);
        }
        return dayjs(formData[name]).format(`DD ${`MMMM`.slice(0, 3)} YYYY`);
    };

    // selected default value for flatpickr
    const calenderValue = () => {
        if (value && typeof value === 'number') {
            return dayjs(value * 1000)?.format('YYYY-MM-DD');
        }
        return dayjs(value).format('YYYY-MM-DD');
    };

    // --check if the edit mode is on
    const isEditMode =
        Object.keys(formData)?.toString() === 'dateOfBirth' &&
        formData?.[name]?.length &&
        formData?.[name] !== value;

    // --display value
    const displayValue = isEditMode ? inputValue() : value;

    return (
        <div className="flex justify-between items-center w-full p-2 md:p-3 rounded-10 bg-primary-50 overflow-hidden box-border">
            <div className="w-10/12">
                <h3 className="text-primary-700 text-sm md:text-base font-normal">
                    {title || '--'}
                </h3>
                <input
                    type="text"
                    name={name}
                    value={displayValue || ''}
                    readOnly={!isEditMode}
                    className="w-full outline-none text-primary text-base md:text-xl font-medium bg-transparent py-1 px-2 rounded-md relative -left-2"
                />
            </div>

            <div
                className={
                    propertyName?.length && propertyName !== 'dateOfBirth' ? 'hidden' : 'block'
                }
            >
                <ActionButton
                    isEditMode={isEditMode}
                    saveClick={saveClick}
                    cancelEditClick={handleReset}
                    calenderValue={calenderValue}
                    flatpickrRef={flatpickrRef}
                    handelOnChange={handelOnChange}
                    handleButtonClick={handleButtonClick}
                />
            </div>
        </div>
    );
}

export default UserDobInfoCard;
